/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InterimReportResponseDto } from '../../models/interim-report-response-dto';
import { RequestInterimReportGenDto } from '../../models/request-interim-report-gen-dto';

export interface DocumentAiV2ControllerGenerateInterimReport$Params {
  centerId: string;
  type: 'user' | 'center';
      body: RequestInterimReportGenDto
}

export function documentAiV2ControllerGenerateInterimReport(http: HttpClient, rootUrl: string, params: DocumentAiV2ControllerGenerateInterimReport$Params, context?: HttpContext): Observable<StrictHttpResponse<InterimReportResponseDto>> {
  const rb = new RequestBuilder(rootUrl, documentAiV2ControllerGenerateInterimReport.PATH, 'post');
  if (params) {
    rb.query('centerId', params.centerId, {});
    rb.query('type', params.type, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<InterimReportResponseDto>;
    })
  );
}

documentAiV2ControllerGenerateInterimReport.PATH = '/api/document-ai-v2/interim-report-ai';
